import { Slot } from '@radix-ui/react-slot';
import { type ComponentPropsWithRef, type ReactNode } from 'react';

import { Button } from '@repo/ui/Button';
import { useDialog } from '@repo/ui/Dialog/DialogRoot';

export type DialogTriggerProps = ComponentPropsWithRef<'button'> & {
  asChild?: boolean;
  className?: string;
  children: ReactNode;
};

export const DialogTrigger = (props: DialogTriggerProps) => {
  const { asChild, children, className = '', onClick, ...attrs } = props;
  const { open } = useDialog();

  const handleClick: ComponentPropsWithRef<'button'>['onClick'] = (e) => {
    if (onClick) {
      onClick(e);
    }

    open();
  };

  const Component = asChild ? Slot : Button;

  return (
    <Component className={className} onClick={handleClick} {...attrs}>
      {children}
    </Component>
  );
};
